<template>
  <div class="filters-panel">
    <div class="field">
      <label class="label">Номер заявки</label>
      <input
        class="input"
        :value="trip_id"
        @input="onTripId"
        placeholder="Номер транспортировки"
        type="text"
      />
    </div>

    <div class="field field-status">
      <label class="label">Статус заявки</label>
      <div class="select-area">
        <button class="dropdown-summary" type="button" @click="toggleStatusDropdown">
          <span>{{ statusSummary }}</span><span class="chevron">{{ openStatus ? '▲' : '▼' }}</span>
        </button>
        <div v-if="openStatus" :key="'sd-' + statusKey" class="dropdown-menu">
<label class="dropdown-option">
            <input type="checkbox" :checked="status.length === 0" :disabled="status.length === 0" @change="selectAllStatuses" />
            <span>Все статусы</span>
          </label>
          <label v-for="opt in statusOptions" :key="opt.value" class="dropdown-option" @click="handleStatusClick($event, opt.value)">
            <input type="checkbox" :checked="status.length === 0 || status.includes(opt.value)" :disabled="status.length === 1 && status.includes(opt.value)" @change="toggleStatus(opt.value)" />
            <span :class="['status-dot', `dot-${opt.key}`]"></span>
            <span>{{ opt.label }}</span>
          </label>
        </div>
      </div>
      <div v-if="selectedStatusOptions.length > 1 && !isAllStatuses" class="tag-list">
        <button v-for="opt in selectedStatusOptions" :key="opt.value" class="tag" @click="removeStatus(opt.value)">{{ opt.label }} x</button>
      </div>
    </div>

    <div class="field field-source">
      <label class="label">Платформа</label>
      <div class="select-area">
        <button class="dropdown-summary" type="button" @click="toggleSourceDropdown">
          <span>{{ sourceSummary }}</span><span class="chevron">{{ openSource ? '▲' : '▼' }}</span>
        </button>
        <div v-if="openSource" :key="'pd-' + sourceKey" class="dropdown-menu">
          <label class="dropdown-option">
            <input type="checkbox" :checked="source.length === 0" @change="selectAllSources" />
            <span>Все платформы</span>
          </label>
          <label v-for="opt in sourceOptions" :key="opt.value" class="dropdown-option" @click="handleSourceClick($event, opt.value)">
            <input type="checkbox" :checked="source.length === 0 || source.includes(opt.value)" :disabled="source.length === 1 && source.includes(opt.value)" @change="toggleSource(opt.value)" />
            <span>{{ opt.label }}</span>
          </label>
        </div>
      </div>
      <div v-if="source.length > 1" class="tag-list">
        <button v-for="opt in selectedSourceOptions" :key="opt.value" class="tag" @click="removeSource(opt.value)">{{ opt.label }} x</button>
      </div>
    </div>

    <div v-if="registryAvailable" class="field field-client-category">
      <label class="label">Категория клиента</label>
      <div class="select-area">
        <button class="dropdown-summary" type="button" @click="toggleClientCategoryDropdown">
          <span>{{ clientCategorySummary }}</span><span class="chevron">{{ openClientCategory ? '▲' : '▼' }}</span>
        </button>
        <div v-if="openClientCategory" :key="'ccd-' + clientCategoryKey" class="dropdown-menu">
          <label class="dropdown-option">
            <input type="checkbox" :checked="clientCategories.length === 0" @change="selectAllClientCategories" />
            <span>Все категории</span>
          </label>
          <label v-for="opt in clientCategoryOptions" :key="opt.value" class="dropdown-option" @click="handleClientCategoryClick($event, opt.value)">
            <input type="checkbox" :checked="clientCategories.length === 0 || clientCategories.includes(opt.value)" :disabled="clientCategories.length === 1 && clientCategories.includes(opt.value)" @change="toggleClientCategory(opt.value)" />
            <span>{{ opt.label }}</span>
          </label>
        </div>
      </div>
      <div v-if="clientCategories.length > 1" class="tag-list">
        <button v-for="opt in selectedClientCategoryOptions" :key="opt.value" class="tag" @click="removeClientCategory(opt.value)">{{ opt.label }} x</button>
      </div>
    </div>

    <div class="field field-client">
      <label class="label">Клиент</label>
      <div class="select-area">
        <button class="dropdown-summary" type="button" @click="toggleClientDropdown">
          <span>{{ clientSummary }}</span><span class="chevron">{{ openClient ? '▲' : '▼' }}</span>
        </button>
        <div v-if="openClient" class="dropdown-menu city-menu">
          <input class="input city-search" :value="clientQuery" @input="onClientInput" placeholder="Поиск клиента" type="text" />
          <div class="hint">Показаны первые 30 клиентов</div>
          <label class="dropdown-option" :class="{ disabled: !clientOptions.length }">
            <input type="checkbox" :checked="allClientsVisibleSelected" :disabled="!clientOptions.length" @change="toggleAllClientsVisible" />
            <span>{{ clientQuery ? 'Выбрать найденных' : 'Выбрать видимых' }}</span>
          </label>
          <div class="options-list">
            <label v-for="opt in clientOptions" :key="opt.value" class="dropdown-option">
              <input type="checkbox" :checked="clientNames.includes(opt.value)" @change="toggleClientName(opt.value)" />
              <span class="option-text">{{ opt.label }}</span>
              <span class="count">{{ opt.count }}</span>
            </label>
            <div v-if="!clientOptions.length" class="empty-options">Нет вариантов</div>
          </div>
        </div>
      </div>
      <div v-if="clientNames.length" class="tag-list">
        <button v-for="name in clientNames" :key="name" class="tag" @click="removeClientName(name)">{{ name }} x</button>
      </div>
    </div>

    <div class="divider" />

    <div class="field field-from">
      <label class="label">Город отправки</label>
      <div class="select-area">
        <button class="dropdown-summary" type="button" @click="toggleFromDropdown">
          <span>{{ citySummary(fromPoints, 'Все города отправки') }}</span><span class="chevron">{{ openFrom ? '▲' : '▼' }}</span>
        </button>
        <div v-if="openFrom" class="dropdown-menu city-menu">
          <input class="input city-search" :value="fromQuery" @input="onFromPointInput" placeholder="Поиск города" type="text" />
          <div class="hint">Показаны первые 30 городов</div>
          <label class="dropdown-option" :class="{ disabled: !fromOptions.length }">
            <input type="checkbox" :checked="allFromVisibleSelected" :disabled="!fromOptions.length" @change="toggleAllFromVisible" />
            <span>{{ fromQuery ? 'Выбрать найденные' : 'Выбрать видимые' }}</span>
          </label>
          <div class="options-list">
            <label v-for="opt in fromOptions" :key="optionValue(opt)" class="dropdown-option">
              <input type="checkbox" :checked="fromPoints.includes(optionValue(opt))" @change="toggleFromPoint(optionValue(opt))" />
              <span class="option-text">{{ optionLabel(opt) }}</span>
              <span class="count">{{ opt.count }}</span>
            </label>
            <div v-if="!fromOptions.length" class="empty-options">Нет вариантов</div>
          </div>
        </div>
      </div>
      <div v-if="fromPoints.length" class="tag-list">
        <button v-for="pt in fromPoints" :key="pt" class="tag" @click="removeFromPoint(pt)">{{ pt }} x</button>
      </div>
    </div>

    <div class="field field-to">
      <label class="label">Город прибытия</label>
      <div class="select-area">
        <button class="dropdown-summary" type="button" @click="toggleToDropdown">
          <span>{{ citySummary(toPoints, 'Все города прибытия') }}</span><span class="chevron">{{ openTo ? '▲' : '▼' }}</span>
        </button>
        <div v-if="openTo" class="dropdown-menu city-menu">
          <input class="input city-search" :value="toQuery" @input="onToPointInput" placeholder="Поиск города" type="text" />
          <div class="hint">Показаны первые 30 городов</div>
          <label class="dropdown-option" :class="{ disabled: !toOptions.length }">
            <input type="checkbox" :checked="allToVisibleSelected" :disabled="!toOptions.length" @change="toggleAllToVisible" />
            <span>{{ toQuery ? 'Выбрать найденные' : 'Выбрать видимые' }}</span>
          </label>
          <div class="options-list">
            <label v-for="opt in toOptions" :key="optionValue(opt)" class="dropdown-option">
              <input type="checkbox" :checked="toPoints.includes(optionValue(opt))" @change="toggleToPoint(optionValue(opt))" />
              <span class="option-text">{{ optionLabel(opt) }}</span>
              <span class="count">{{ opt.count }}</span>
            </label>
            <div v-if="!toOptions.length" class="empty-options">Нет вариантов</div>
          </div>
        </div>
      </div>
      <div v-if="toPoints.length" class="tag-list">
        <button v-for="pt in toPoints" :key="pt" class="tag" @click="removeToPoint(pt)">{{ pt }} x</button>
      </div>
    </div>

    <div class="divider" />

    <div class="field">
      <label class="label">Дата отправки</label>
      <input class="input" type="date" :value="loadingDateFrom" @input="onDateFrom" />
    </div>

    <div class="field">
      <label class="label">Дата прибытия</label>
      <input class="input" type="date" :value="loadingDateTo" @input="onDateTo" />
    </div>

    <div class="date-presets-block">
      <span class="presets-title">Быстрый выбор периода</span>
      <div class="chip-group date-presets">
        <button
          v-for="preset in datePresets"
          :key="preset.label"
          :class="['chip', 'preset-chip', { active: preset.active }]"
          @click="applyPreset(preset)"
        >{{ preset.label }}</button>
      </div>
    </div>

    <div class="divider" />

    <div class="field">
      <label class="label">Тип ТС</label>
      <select class="input select" :value="vehicleType" @change="onVehicleType">
        <option value="">Все типы ТС</option>
        <option value="TENT">TENT</option>
        <option value="ISO">ISO</option>
        <option value="REF">REF</option>
      </select>
    </div>

    <div class="field">
      <label class="label">Исполнитель</label>
      <input
        class="input"
        :value="worker"
        @input="onWorker"
        placeholder="Исполнитель"
        type="text"
      />
    </div>

    <button class="btn-clear" @click="clearAll">Сбросить фильтры</button>
  </div>
</template>

<script>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { useQueryClient } from '@tanstack/vue-query';
import { fetchCityOptions, fetchClientOptions, fetchClientRegistryStatus } from '@/backend/distributionApi';

function formatDate(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function getMonday(d) {
  const date = new Date(d);
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  date.setDate(date.getDate() + diff);
  return date;
}

function getLastDayOfMonth(year, month) {
  return new Date(year, month + 1, 0);
}

const SOURCE_OPTIONS = [
  { value: 'Магнит (Гарантии)', label: 'Гарантии (Магнит)' },
  { value: 'Эфес (Гарантии)', label: 'Гарантии (Эфес)' },
  { value: 'СПОТ (Логинет)', label: 'СПОТ (Логинет)' },
  { value: 'СПОТ (Сельта)', label: 'СПОТ (Сельта)' },
  { value: 'СПОТ (Эфес)', label: 'СПОТ (Эфес)' },
  { value: 'СПОТ (ОПХ)', label: 'СПОТ (ОПХ)' },
];

const CLIENT_CATEGORY_OPTIONS = [
  { value: 'top', label: 'ТОП' },
  { value: 'key', label: 'Ключевой' },
  { value: 'regular', label: 'Обычный' },
];

const STATUS_BASE = [
  { value: 1, key: 'opened', label: 'Открыт' },
  { value: 2, key: 'closed', label: 'Закрыт' },
  { value: 4, key: 'canceled', label: 'Отменен' },
];
const STATUS_EXTRA = [
  { value: 8, key: 'deleted', label: 'Удален' },
  { value: 16, key: 'outdated', label: 'Устарел' },
  { value: 32, key: 'breakdown', label: 'Срыв' },
  { value: 64, key: 'refusal', label: 'Отказ' },
];

export default {
  name: 'DistributionFilters',
  props: {
    filters: { type: Object, required: true },
    hasManualStatusPermission: { type: Boolean, default: false },
  },
  emits: ['change', 'clear'],
  setup(props, { emit }) {
    const queryClient = useQueryClient();
    const state = computed(() => props.filters);
    const fromQuery = ref('');
    const toQuery = ref('');
    const fromOptions = ref([]);
    const toOptions = ref([]);
    const clientQuery = ref('');
    const clientOptions = ref([]);
    const registryAvailable = ref(true);
    const openStatus = ref(false);
    const openSource = ref(false);
    const openFrom = ref(false);
    const openTo = ref(false);
    const openClientCategory = ref(false);
    const openClient = ref(false);
    const statusKey = ref(0);
    const sourceKey = ref(0);
    const clientCategoryKey = ref(0);

    const toggleStatusDropdown = () => {
      openStatus.value = !openStatus.value;
      if (openStatus.value) statusKey.value++;
    };
    const toggleSourceDropdown = () => {
      openSource.value = !openSource.value;
      if (openSource.value) sourceKey.value++;
    };

    const datePresets = computed(() => {
      const from = state.value.loadingDateFrom;
      const to = state.value.loadingDateTo;
      const today = new Date();
      const now = formatDate(today);

      const d = new Date();
      d.setDate(d.getDate() + 1);
      const tomorrow = formatDate(d);

      const d2 = new Date();
      d2.setDate(d2.getDate() + 2);
      const afterTomorrow = formatDate(d2);

      const dMinus = new Date();
      dMinus.setDate(dMinus.getDate() - 1);
      const yesterday = formatDate(dMinus);

      const monday = getMonday(today);
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);
      const thisWeek = { from: formatDate(monday), to: formatDate(sunday) };

      const prevMonday = new Date(monday);
      prevMonday.setDate(monday.getDate() - 7);
      const prevSunday = new Date(prevMonday);
      prevSunday.setDate(prevMonday.getDate() + 6);
      const prevWeek = { from: formatDate(prevMonday), to: formatDate(prevSunday) };

      const nextMonday = new Date(monday);
      nextMonday.setDate(monday.getDate() + 7);
      const nextSunday = new Date(nextMonday);
      nextSunday.setDate(nextMonday.getDate() + 6);
      const nextWeek = { from: formatDate(nextMonday), to: formatDate(nextSunday) };

      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = getLastDayOfMonth(today.getFullYear(), today.getMonth());
      const thisMonth = { from: formatDate(firstDay), to: formatDate(lastDay) };

      const plus3 = new Date();
      plus3.setDate(plus3.getDate() + 3);
      const minus3 = new Date();
      minus3.setDate(minus3.getDate() - 3);

      const presets = [
        { label: 'Сегодня', range: { from: now, to: now } },
        { label: 'Завтра', range: { from: tomorrow, to: tomorrow } },
        { label: 'Послезавтра', range: { from: afterTomorrow, to: afterTomorrow } },
        { label: 'Вчера', range: { from: yesterday, to: yesterday } },
        { label: 'Тек. неделя', range: thisWeek },
        { label: 'Прош. неделя', range: prevWeek },
        { label: 'След. неделя', range: nextWeek },
        { label: 'Тек. месяц', range: thisMonth },
        { label: '+3 дня', range: { from: now, to: formatDate(plus3) } },
        { label: '-3 дня', range: { from: formatDate(minus3), to: now } },
      ];

      return presets.map((p) => ({
        ...p,
        active: from === p.range.from && to === p.range.to,
      }));
    });

    const applyPreset = (preset) => {
      const from = state.value.loadingDateFrom;
      const to = state.value.loadingDateTo;
      if (from === preset.range.from && to === preset.range.to) {
        emit('change', { loadingDateFrom: '', loadingDateTo: '' });
        return;
      }
      emit('change', { loadingDateFrom: preset.range.from, loadingDateTo: preset.range.to });
    };

    const sourceValues = SOURCE_OPTIONS.map((option) => option.value);
    const statusOptions = computed(() => (
      props.hasManualStatusPermission ? [...STATUS_BASE, ...STATUS_EXTRA] : STATUS_BASE
    ));
    const statusValues = computed(() => statusOptions.value.map((option) => option.value));

    const normalizeSourceValue = (nextValue) => {
      if (nextValue.length === sourceValues.length && sourceValues.every((item) => nextValue.includes(item))) {
        emit('change', { source: [] });
        return;
      }
      emit('change', { source: nextValue });
    };

    const toggleSource = (val) => {
      const cur = state.value.source;
      const currentValue = cur.length === 0 ? sourceValues : cur;
      const next = currentValue.includes(val) ? currentValue.filter((v) => v !== val) : [...currentValue, val];
      if (next.length > 0) normalizeSourceValue(next);
    };

    const handleSourceClick = (event, val) => {
      if (!event.shiftKey) return;
      event.preventDefault();
      event.stopPropagation();
      emit('change', { source: [val] });
    };

    const normalizeStatusValue = (nextValue) => {
      if (nextValue.length === 0) return;
      if (nextValue.length === statusValues.value.length && statusValues.value.every((item) => nextValue.includes(item))) {
        emit('change', { status: [] });
        return;
      }
      emit('change', { status: nextValue });
    };

    const toggleStatus = (val) => {
      const cur = state.value.status;
      const currentValue = cur.length === 0 ? statusValues.value : cur;
      const next = currentValue.includes(val) ? currentValue.filter((v) => v !== val) : [...currentValue, val];
      normalizeStatusValue(next);
    };

    const handleStatusClick = (event, val) => {
      if (!event.shiftKey) return;
      event.preventDefault();
      event.stopPropagation();
      emit('change', { status: [val] });
    };

    const selectAllStatuses = () => emit('change', { status: [] });
    const selectAllSources = () => emit('change', { source: [] });
    const removeStatus = (val) => {
      const cur = state.value.status.length === 0 ? statusValues.value : state.value.status;
      const next = cur.filter((item) => item !== val);
      if (next.length > 0) normalizeStatusValue(next);
    };
    const removeSource = (val) => {
      const cur = state.value.source.length === 0 ? sourceValues : state.value.source;
      const next = cur.filter((item) => item !== val);
      if (next.length > 0) normalizeSourceValue(next);
    };

    const clientCategoryValues = CLIENT_CATEGORY_OPTIONS.map((option) => option.value);

    const toggleClientCategoryDropdown = () => {
      openClientCategory.value = !openClientCategory.value;
      if (openClientCategory.value) clientCategoryKey.value++;
    };

    const normalizeClientCategoryValue = (nextValue) => {
      if (nextValue.length === 0) return;
      if (nextValue.length === clientCategoryValues.length && clientCategoryValues.every((item) => nextValue.includes(item))) {
        emit('change', { clientCategories: [] });
        return;
      }
      emit('change', { clientCategories: nextValue });
    };

    const toggleClientCategory = (val) => {
      const cur = state.value.clientCategories;
      const currentValue = cur.length === 0 ? clientCategoryValues : cur;
      const next = currentValue.includes(val) ? currentValue.filter((v) => v !== val) : [...currentValue, val];
      if (next.length > 0) normalizeClientCategoryValue(next);
    };

    const handleClientCategoryClick = (event, val) => {
      if (!event.shiftKey) return;
      event.preventDefault();
      event.stopPropagation();
      emit('change', { clientCategories: [val] });
    };

    const selectAllClientCategories = () => emit('change', { clientCategories: [] });

    const removeClientCategory = (val) => {
      const cur = state.value.clientCategories.length === 0 ? clientCategoryValues : state.value.clientCategories;
      const next = cur.filter((item) => item !== val);
      if (next.length > 0) normalizeClientCategoryValue(next);
    };

    const normalizeOption = (value) => (typeof value === 'string' ? value : value?.value || value?.label || value?.city_name || '');
    const optionValue = (option) => normalizeOption(option);
    const optionLabel = (option) => (typeof option === 'string' ? option : option?.label || option?.value || option?.city_name || '');
    const citySummary = (items, placeholder) => (items.length === 1 ? items[0] : items.length > 1 ? `Выбрано: ${items.length}` : placeholder);

    let fromRequest = 0;
    let toRequest = 0;
    const loadCityOptions = async (kind, q, target) => {
      const requestId = kind === 'departure' ? ++fromRequest : ++toRequest;
      const key = ['distribution-cities', kind, q || '', state.value.status, state.value.source, state.value.loadingDateFrom, state.value.loadingDateTo];
      await queryClient.cancelQueries({ queryKey: ['distribution-cities', kind] });
      try {
        const data = await queryClient.fetchQuery({
          queryKey: key,
          staleTime: 30000,
          queryFn: ({ signal }) => fetchCityOptions({
            kind,
            q: q || undefined,
            limit: 30,
            status: state.value.status.length ? state.value.status : undefined,
            display_name: state.value.source.length ? state.value.source : undefined,
            loading_date_from: state.value.loadingDateFrom || undefined,
            loading_date_to: state.value.loadingDateTo || undefined,
          }, { signal }),
        });
        const latest = kind === 'departure' ? fromRequest : toRequest;
        if (requestId === latest) target.value = data?.items || [];
      } catch (error) {
        if (error?.code !== 'ERR_CANCELED') target.value = [];
      }
    };
    const loadFromOptions = (q) => loadCityOptions('departure', q, fromOptions);
    const loadToOptions = (q) => loadCityOptions('destination', q, toOptions);

    let clientRequest = 0;
    const loadClientOptions = async (q) => {
      const requestId = ++clientRequest;
      const key = ['distribution-clients', q || ''];
      await queryClient.cancelQueries({ queryKey: ['distribution-clients'] });
      try {
        const data = await queryClient.fetchQuery({
          queryKey: key,
          staleTime: 30000,
          queryFn: ({ signal }) => fetchClientOptions({
            q: q || undefined,
            limit: 30,
          }, { signal }),
        });
        if (requestId === clientRequest) clientOptions.value = data?.items || [];
      } catch (error) {
        if (error?.code !== 'ERR_CANCELED') clientOptions.value = [];
      }
    };

    const toggleClientDropdown = () => {
      openClient.value = !openClient.value;
      if (openClient.value && clientOptions.value.length === 0) loadClientOptions(undefined);
    };

    const toggleClientName = (value) => {
      const name = String(value || '').trim();
      if (!name) return;
      const current = state.value.clientNames;
      const next = current.includes(name) ? current.filter((item) => item !== name) : [...current, name];
      emit('change', { clientNames: next });
    };

    const removeClientName = (name) => {
      emit('change', { clientNames: state.value.clientNames.filter((v) => v !== name) });
    };

    const toggleAllClientsVisible = () => {
      const visible = clientOptions.value.map(optionValue).filter(Boolean);
      if (!visible.length) return;
      const current = state.value.clientNames;
      const allSelected = visible.every((item) => current.includes(item));
      emit('change', { clientNames: allSelected
        ? current.filter((item) => !visible.includes(item))
        : [...new Set([...current, ...visible])] });
    };

    let clientTimer = null;
    const onClientInput = (e) => {
      clearTimeout(clientTimer);
      const val = e.target.value;
      clientQuery.value = val;
      clientTimer = setTimeout(() => {
        if (!val.trim()) {
          clientOptions.value = [];
          return;
        }
        loadClientOptions(val);
      }, 300);
    };

    const toggleFromDropdown = () => {
      openFrom.value = !openFrom.value;
      if (openFrom.value && fromOptions.value.length === 0) loadFromOptions(undefined);
    };

    const toggleToDropdown = () => {
      openTo.value = !openTo.value;
      if (openTo.value && toOptions.value.length === 0) loadToOptions(undefined);
    };

    const addFromPoint = (value) => {
      const city = normalizeOption(value).trim();
      if (!city) return;
      if (!state.value.fromPoints.includes(city)) {
        emit('change', { fromPoints: [...state.value.fromPoints, city] });
      }
      fromQuery.value = '';
      fromOptions.value = [];
    };

    const toggleFromPoint = (value) => {
      const city = normalizeOption(value).trim();
      if (!city) return;
      const current = state.value.fromPoints;
      const next = current.includes(city) ? current.filter((item) => item !== city) : [...current, city];
      emit('change', { fromPoints: next });
    };

    const toggleToPoint = (value) => {
      const city = normalizeOption(value).trim();
      if (!city) return;
      const current = state.value.toPoints;
      const next = current.includes(city) ? current.filter((item) => item !== city) : [...current, city];
      emit('change', { toPoints: next });
    };

    const toggleAllFromVisible = () => {
      const visible = fromOptions.value.map(optionValue).filter(Boolean);
      if (!visible.length) return;
      const current = state.value.fromPoints;
      const allSelected = visible.every((item) => current.includes(item));
      emit('change', { fromPoints: allSelected
        ? current.filter((item) => !visible.includes(item))
        : [...new Set([...current, ...visible])] });
    };

    const toggleAllToVisible = () => {
      const visible = toOptions.value.map(optionValue).filter(Boolean);
      if (!visible.length) return;
      const current = state.value.toPoints;
      const allSelected = visible.every((item) => current.includes(item));
      emit('change', { toPoints: allSelected
        ? current.filter((item) => !visible.includes(item))
        : [...new Set([...current, ...visible])] });
    };

    const addToPoint = (value) => {
      const city = normalizeOption(value).trim();
      if (!city) return;
      if (!state.value.toPoints.includes(city)) {
        emit('change', { toPoints: [...state.value.toPoints, city] });
      }
      toQuery.value = '';
      toOptions.value = [];
    };

    let fromTimer = null;
    const onFromPointInput = (e) => {
      clearTimeout(fromTimer);
      const val = e.target.value;
      fromQuery.value = val;
      fromTimer = setTimeout(() => {
        if (!val.trim()) {
          fromOptions.value = [];
          return;
        }
        loadFromOptions(val);
      }, 300);
    };

    let toTimer = null;
    const onToPointInput = (e) => {
      clearTimeout(toTimer);
      const val = e.target.value;
      toQuery.value = val;
      toTimer = setTimeout(() => {
        if (!val.trim()) {
          toOptions.value = [];
          return;
        }
        loadToOptions(val);
      }, 300);
    };

    let tripTimer = null;
    const onTripId = (e) => {
      clearTimeout(tripTimer);
      const val = e.target.value;
      tripTimer = setTimeout(() => {
        emit('change', { trip_id: val });
      }, 500);
    };

    let workerTimer = null;
    const onWorker = (e) => {
      clearTimeout(workerTimer);
      const value = e.target.value;
      workerTimer = setTimeout(() => emit('change', { worker: value }), 500);
    };

    const onDateFrom = (e) => emit('change', { loadingDateFrom: e.target.value });
    const onDateTo = (e) => emit('change', { loadingDateTo: e.target.value });
    const onVehicleType = (e) => emit('change', { vehicleType: e.target.value });

    const removeFromPoint = (pt) => {
      emit('change', { fromPoints: state.value.fromPoints.filter((v) => v !== pt) });
    };
    const removeToPoint = (pt) => {
      emit('change', { toPoints: state.value.toPoints.filter((v) => v !== pt) });
    };

    const clearAll = () => emit('clear');

    const handleClickOutside = (e) => {
      if (openStatus.value && !e.target.closest('.field-status')) {
        openStatus.value = false;
      }
      if (openSource.value && !e.target.closest('.field-source')) {
        openSource.value = false;
      }
      if (openClientCategory.value && !e.target.closest('.field-client-category')) {
        openClientCategory.value = false;
      }
      if (openClient.value && !e.target.closest('.field-client')) {
        openClient.value = false;
      }
      if (openFrom.value && !e.target.closest('.field-from')) {
        openFrom.value = false;
      }
      if (openTo.value && !e.target.closest('.field-to')) {
        openTo.value = false;
      }
    };

    onMounted(() => {
      window.addEventListener('click', handleClickOutside);
      fetchClientRegistryStatus()
        .then((status) => {
          if (status && status.available === false) registryAvailable.value = false;
        })
        .catch(() => {});
    });
    onBeforeUnmount(() => {
      window.removeEventListener('click', handleClickOutside);
      clearTimeout(fromTimer);
      clearTimeout(toTimer);
      clearTimeout(tripTimer);
      clearTimeout(workerTimer);
      clearTimeout(clientTimer);
      queryClient.cancelQueries({ queryKey: ['distribution-cities'] });
      queryClient.cancelQueries({ queryKey: ['distribution-clients'] });
    });

    return {
      trip_id: computed(() => state.value.trip_id),
      source: computed(() => state.value.source),
      statusKey,
      sourceKey,
      fromQuery,
      toQuery,
      fromOptions,
      toOptions,
      openStatus,
      openSource,
      openFrom,
      openTo,
      fromPoints: computed(() => state.value.fromPoints),
      toPoints: computed(() => state.value.toPoints),
      clientCategories: computed(() => state.value.clientCategories),
      clientNames: computed(() => state.value.clientNames),
      registryAvailable,
      vehicleType: computed(() => state.value.vehicleType),
      worker: computed(() => state.value.worker),
      loadingDateFrom: computed(() => state.value.loadingDateFrom),
      loadingDateTo: computed(() => state.value.loadingDateTo),
      status: computed(() => state.value.status),
      isAllStatuses: computed(() => state.value.status.length === 0 || statusValues.value.every((item) => state.value.status.includes(item))),
      selectedStatusOptions: computed(() => state.value.status.length === 0 ? statusOptions.value : statusOptions.value.filter((option) => state.value.status.includes(option.value))),
      selectedSourceOptions: computed(() => SOURCE_OPTIONS.filter((option) => state.value.source.includes(option.value))),
      allFromVisibleSelected: computed(() => fromOptions.value.length > 0 && fromOptions.value.map(optionValue).every((item) => state.value.fromPoints.includes(item))),
      allToVisibleSelected: computed(() => toOptions.value.length > 0 && toOptions.value.map(optionValue).every((item) => state.value.toPoints.includes(item))),
      statusSummary: computed(() => {
        if (!state.value.status.length) return 'Все статусы';
        if (state.value.status.length === 1) {
          return statusOptions.value.find((o) => o.value === state.value.status[0])?.label || '';
        }
        return `Выбрано: ${state.value.status.length}`;
      }),
      sourceSummary: computed(() => {
        if (!state.value.source.length) return 'Все платформы';
        if (state.value.source.length === 1) {
          return SOURCE_OPTIONS.find((o) => o.value === state.value.source[0])?.label || state.value.source[0];
        }
        return `Выбрано: ${state.value.source.length}`;
      }),
      sourceOptions: SOURCE_OPTIONS,
      statusOptions,
      clientCategoryOptions: CLIENT_CATEGORY_OPTIONS,
      clientQuery,
      clientOptions,
      openClientCategory,
      openClient,
      clientCategoryKey,
      toggleClientCategoryDropdown,
      toggleClientCategory,
      handleClientCategoryClick,
      selectAllClientCategories,
      removeClientCategory,
      clientCategorySummary: computed(() => {
        if (!state.value.clientCategories.length) return 'Все категории';
        if (state.value.clientCategories.length === 1) {
          return CLIENT_CATEGORY_OPTIONS.find((o) => o.value === state.value.clientCategories[0])?.label || '';
        }
        return `Выбрано: ${state.value.clientCategories.length}`;
      }),
      selectedClientCategoryOptions: computed(() => CLIENT_CATEGORY_OPTIONS.filter((option) => state.value.clientCategories.includes(option.value))),
      clientSummary: computed(() => {
        if (!state.value.clientNames.length) return 'Все клиенты';
        if (state.value.clientNames.length === 1) return state.value.clientNames[0];
        return `Выбрано: ${state.value.clientNames.length}`;
      }),
      allClientsVisibleSelected: computed(() => clientOptions.value.length > 0 && clientOptions.value.map(optionValue).every((item) => state.value.clientNames.includes(item))),
      toggleClientDropdown,
      toggleClientName,
      removeClientName,
      toggleAllClientsVisible,
      onClientInput,
      datePresets,
      applyPreset,
      toggleSource,
      handleSourceClick,
      selectAllSources,
      removeSource,
      toggleStatus,
      toggleSourceDropdown,
      toggleStatusDropdown,
      handleStatusClick,
      selectAllStatuses,
      removeStatus,
      optionValue,
      optionLabel,
      citySummary,
      toggleFromDropdown,
      toggleToDropdown,
      onTripId,
      onFromPointInput,
      onToPointInput,
      addFromPoint,
      addToPoint,
      toggleFromPoint,
      toggleToPoint,
      toggleAllFromVisible,
      toggleAllToVisible,
      onWorker,
      onDateFrom,
      onDateTo,
      onVehicleType,
      removeFromPoint,
      removeToPoint,
      clearAll,
    };
  },
};
</script>

<style scoped>
.filters-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  font-size: 14px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 2px;
}

.input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background: #fff;
  color: #333;
  box-sizing: border-box;
}

.input.select {
  cursor: pointer;
}

.select-area {
  position: relative;
}

.dropdown-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 7px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  min-height: 18px;
  box-sizing: border-box;
  gap: 6px;
}

.chevron {
  flex-shrink: 0;
  color: #007bff;
  font-size: 12px;
}

.dropdown-menu {
  position: absolute;
  z-index: 20;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  max-height: 220px;
  overflow-y: auto;
  padding: 6px;
  border: 1px solid #d7dce2;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.12);
  user-select: none;
}

.city-menu {
  max-height: 340px;
}

.city-search {
  margin-bottom: 6px;
  box-sizing: border-box;
  width: 100%;
}

.hint {
  margin-bottom: 4px;
  color: #888;
  font-size: 12px;
}

.options-list {
  display: flex;
  flex-direction: column;
  max-height: 180px;
  overflow-y: auto;
  background: #fff;
  border: 0;
  border-radius: 0;
}

.option-btn {
  padding: 6px 8px;
  border: none;
  background: #fff;
  color: #333;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}

.option-btn:hover {
  background: #f3f6fb;
}

.dropdown-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 8px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.dropdown-option:hover {
  background: rgba(224, 187, 72, 0.18);
}

.dropdown-option input {
  accent-color: #007bff;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dot-opened { background: #007bff; }
.dot-closed { background: #28a745; }
.dot-canceled { background: #dc3545; }
.dot-deleted { background: #6c757d; }
.dot-outdated { background: #a87836; }
.dot-breakdown { background: #fd7e14; }
.dot-refusal { background: #6f42c1; }
.dot-unknown { background: #adb5bd; }

.dropdown-option.disabled {
  color: #999;
  cursor: default;
}

.option-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.count,
.empty-options {
  color: #888;
  font-size: 12px;
}

.empty-options {
  padding: 8px;
}

.chip-group {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.chip {
  padding: 3px 8px;
  border: 1px solid #ccc;
  border-radius: 12px;
  font-size: 13px;
  background: #fff;
  color: #333;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.chip.active {
  background: #007bff;
  border-color: #007bff;
  color: #fff;
}

.chip:hover {
  border-color: #007bff;
}

.date-presets-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f7f8fa;
}

.presets-title {
  font-size: 13px;
  font-weight: 600;
  color: #555;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 6px;
  border: 1px solid #007bff;
  border-radius: 10px;
  font-size: 12px;
  cursor: pointer;
  color: #007bff;
  background: #e8f0fe;
  line-height: 1.4;
}

.tag-remove {
  border: none;
  background: none;
  color: #d33;
  cursor: pointer;
  font-size: 12px;
  padding: 0 2px;
  line-height: 1;
}

.divider {
  height: 1px;
  background: #e5e7eb;
}

.btn-clear {
  padding: 6px 12px;
  border: 1px solid #b83235;
  border-radius: 4px;
  background: #fff;
  color: #b83235;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-clear:hover {
  background: #b83235;
  color: #fff;
}
</style>
